import { NOTIFICATION_TYPE } from '../constants/common'
import {
  NOTIFICATION_FILE_UPLOAD,
  NOTIFICATION_FILE_UPLOADED_WITH_ERRORS,
  NOTIFICATION_INCORRECT_FIELD_VALUE,
  NOTIFICATION_NO_CHANGES,
} from '../constants/notification'

export function isNotificationTypeInfo(type) {
  return type === NOTIFICATION_TYPE.info
}

export function getFormNotificationFilesIsUploading(t) {
  return {
    id: NOTIFICATION_FILE_UPLOAD,
    text: t('Form.CommonUploadFilesWarningKey'),
    type: NOTIFICATION_TYPE.warning,
  }
}

export function getFormNotificationFilesWithErrors(t) {
  return {
    id: NOTIFICATION_FILE_UPLOADED_WITH_ERRORS,
    text: t('Form.CommonRemoveFileWithErrorsToSubmitKey'),
    type: NOTIFICATION_TYPE.error,
  }
}

export function getFormNotificationIncorrectFieldValue(t) {
  return {
    id: NOTIFICATION_INCORRECT_FIELD_VALUE,
    text: t('Form.CommonIncorrectFieldValueKey'),
    type: NOTIFICATION_TYPE.error,
  }
}

export function getNotificationNoChanged(t) {
  return {
    id: NOTIFICATION_NO_CHANGES,
    text: t('Notification.InfoMakeChangesToApplyKey'),
    type: NOTIFICATION_TYPE.info,
  }
}
